var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActionBarTriggerDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.16142 1 1 6.16144 1 12.5 1 18.838589 6.16142 24 12.5 24S24 18.838589 24 12.5C24 6.16144 18.83858 1 12.5 1zm-2.106105 6.418605c-.5819.013907-1.08832.510493-1.103197 1.220203v7.714042c.01987.946263.914547 1.520247 1.696584 1.069768l6.284884-3.869563c.342502-.21136.576671-.599284.576671-1.053052 0-.453769-.23417-.841712-.576671-1.053045l-6.284884-3.869546c-.19551-.11262-.39942-.163434-.593387-.158807z",
    stroke: "#90a9c0",
    strokeWidth: 2,
    fill: "#90a9c0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.393895 7.418605c-.5819.013907-1.08832.510493-1.103197 1.220203v7.714042c.01987.946263.914547 1.520247 1.696584 1.069768l6.284884-3.869563c.342502-.21136.576671-.599284.576671-1.053052 0-.453769-.23417-.841712-.576671-1.053045l-6.284884-3.869546c-.19551-.11262-.39942-.163434-.593387-.158807z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionBarTriggerDisabled);
export default __webpack_public_path__ + "static/media/icon-action-bar-trigger-disabled.de29cfc211131f08ec3efb9a32b58a35.svg";
export { ForwardRef as ReactComponent };